export { default } from './InteractiveSurveyCover';
export * from './InteractiveSurveyCover';
